export let agoraOptions = {
   appID: process.env.VUE_APP_AGORA_APP_ID,
   channel: "Agora Channel",
   uid: null,
   token: null
};

export const RTM_CONFIGS = {
   CHANNEL_EVENTS: [
      "ChannelMessage",
      // "MemberJoined",
      // "MemberLeft",
      "MemberCountUpdated"
   ],
   PREFIX_METHOD: "received"
};

export const LOCAL_CHAT_CONFIG = {
   DELAY_TIME_TO_SAVE: 30, // seconds
   MAXIMUM_MESSAGES: 100
};

export const STREAM_MESSAGES_CONFIG = {
   AUTO_GENERATE_TEST_MESSAGES: true,
   MAXIMUM_MESSAGES: 100,
   TIME_PER_MESSAGE: 500 // millisecond
};

export const ENV_CONFIGS = {
   IS_LOCAL: process.env.NODE_ENV === "development",
   IS_HARD_URL: false,
   IS_SHOW_DEBUG: process.env.VUE_APP_NODE_ENV !== "production"
};

export const LIMIT_CHAT_CONFIGS = {
   WAITING_TIME: 5, // seconds
   CAP_TARGET_MESSAGES: 50,
   THRESHOLD_MESSAGES: 180,
   INTERVAL: 1 // seconds
};

export const STREAM_CONFIGS = {
   TIME_GET_STATISTIC: 20, // seconds
   TIME_TRACKING_LIKE: 10, // seconds
   TIME_TRACKING_USER_JOIN: 10, // seconds
};

export const EVENT_TYPES = {
   FREE: 0,
   PAID: 1
};

export const VIDEO_PLAYER_CONFIGS = {
   TIME_WAITING_ERROR: 30 // seconds,
};

export const RAKUTEN_LOGIN_URL = process.env.VUE_APP_RAKUTEN_LOGIN_URL;
export const MAPPING_URL_SOURCES = {
   BROADCASTER: "Broadcaster_feed",
   DATA_FEED: "feeds",
   DESCRIPTION: "description"
};

export const REGEXS = {
	// eslint-disable-next-line
	ANY_URL:  /(((https?:(\/\/)?(www\.)?([a-zA-Z0-9\-]+?\.){0,2})([a-zA-Z0-9\-]+?)\.([a-zA-Z]+))(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/gi,
   // eslint-disable-next-line
   VIEW_URL:  /(((((https?:)(\/\/)?(www\.)?|(\/\/)?(www\.))([a-zA-Z0-9\-]+?\.){0,2})([a-zA-Z0-9\-]+?)\.([a-zA-Z]+))(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/gi,
}